import { FC, useMemo } from 'react';
import { UserInfo } from '@cld/application-wrapper-common';

const getValue = (value?: string) => value || '';

const getSpace = (userInfo?: UserInfo) => (userInfo?.firstName && userInfo?.lastName ? ' ' : '');

export const getUserName = (userInfo?: UserInfo) => `${getValue(userInfo?.firstName)}${getSpace(userInfo)}${getValue(userInfo?.lastName)}`;

export const UserAvatarTooltip: FC<React.PropsWithChildren<{ userInfo?: UserInfo }>> = ({ userInfo }) => {
  const name = useMemo(() => getUserName(userInfo), [userInfo]);

  return (
    <>
      <div>{name}</div>
      {userInfo?.email && <div>{userInfo.email}</div>}
    </>
  );
};
